// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_alert_banner-PlasmicPromoBanner-module__root-oGXq_I","text":"src-wab-client-plasmic-plasmic_kit_alert_banner-PlasmicPromoBanner-module__text-uuBwEA"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_alert_banner-PlasmicPromoBanner-module__root-oGXq_I\",\"text\":\"src-wab-client-plasmic-plasmic_kit_alert_banner-PlasmicPromoBanner-module__text-uuBwEA\"}";
        // 1793541989751
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  